import { jsx as l } from "react/jsx-runtime";
import "@smart/web-foundations";
import { c } from "./chunks/index.rKuIKazb.js";
import { Flex as u } from "./flex.js";
import { Text as p } from "./text.js";
import _ from "react";
import './assets/list.css';const d = "_list_xyulk_3", f = "_ol_xyulk_6", x = "_ul_xyulk_9", o = {
  list: d,
  ol: f,
  ul: x
}, m = _.forwardRef(
  ({ children: i, className: s }, t) => {
    const e = c(o["list-item"], s);
    return /* @__PURE__ */ l("li", { ref: t, className: e, children: i });
  }
);
m.displayName = "List.Item";
const r = ({
  children: i,
  className: s,
  as: t = "ul",
  gap: e = 200,
  ...a
}) => {
  const n = c(
    o.list,
    {
      [o.ol]: t === "ul",
      [o.ul]: t === "ol"
    },
    s
  );
  return /* @__PURE__ */ l(
    p,
    {
      className: n,
      margin: { bottom: 400 },
      padding: { left: 400 },
      ...a,
      asChild: !0,
      children: /* @__PURE__ */ l(t === "ul" ? "ul" : "ol", { className: s, children: /* @__PURE__ */ l(u, { direction: "column", gap: e, children: i }) })
    }
  );
}, T = Object.assign(r, {
  Item: m
});
r.displayName = "List";
export {
  T as List
};
//# sourceMappingURL=list.js.map
